import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  // Get user information from localStorage
  const userRole = localStorage.getItem('userRole') || 'User';
  const userName = localStorage.getItem('userName') || 'User';
  const userEmail = localStorage.getItem('userEmail') || 'user@example.com';
  const isAdmin = userRole === 'Admin';

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userRole');
    localStorage.removeItem('userName');
    localStorage.removeItem('userEmail');
    localStorage.removeItem('userId');
    navigate('/login');
  };

  const menuItems = [
    {
      name: 'Dashboard',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2-2z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 5a2 2 0 012-2h4a2 2 0 012 2v6H8V5z" />
        </svg>
      ),
      path: '/dashboard',
      show: true
    },
    {
      name: 'Users Management',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
        </svg>
      ),
      path: '/users',
      show: isAdmin
    },
    {
      name: 'AI Agents',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
      ),
      path: '/ai-agents',
      show: true
    },

    {
      name: 'Feedbacks',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v12a2 2 0 01-2 2h-3l-4 4z" />
        </svg>
      ),
      path: '/feedbacks',
      show: isAdmin
    },
    {
      name: 'Profile',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
        </svg>
      ),
      path: '/profile',
      show: true
    },
    {
      name: 'Analytics',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
      ),
      path: '/analytics',
      show: isAdmin
    }
  ];

  return (
    <div className={`bg-white h-screen transition-all duration-300 ease-in-out ${isOpen ? 'w-72' : 'w-20'}`}>
      {/* Header */}
      <div className={`flex items-center justify-between border-b border-gray-200 ${isOpen ? 'p-6' : 'p-4'}`}>
        {isOpen && (
          <div className="flex items-center space-x-3">
            <div className="w-8 h-8 bg-black rounded-lg flex items-center justify-center">
              <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
            </div>
            <h2 className="text-xl font-bold text-black">
              Sobrus Agents
            </h2>
          </div>
        )}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className={`rounded-xl hover:bg-gray-100 transition-all duration-200 hover:scale-105 ${isOpen ? 'p-2' : 'p-1.5'}`}
        >
          <svg className={`text-gray-600 transition-transform duration-300 ${isOpen ? 'w-5 h-5 rotate-180' : 'w-4 h-4'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 5l7 7-7 7M5 5l7 7-7 7" />
          </svg>
        </button>
      </div>

      {/* User Profile Section */}
      <div className={`border-b border-gray-200 ${isOpen ? 'p-6' : 'p-4'}`}>
        <div className="flex items-center space-x-4">
          <div className="relative">
            <div className={`bg-black rounded-full flex items-center justify-center ${isOpen ? 'w-12 h-12' : 'w-10 h-10'}`}>
              <svg className={`text-white ${isOpen ? 'w-6 h-6' : 'w-5 h-5'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
            </div>
            <div className={`absolute border-2 border-white rounded-full bg-green-400 ${isOpen ? '-bottom-1 -right-1 w-4 h-4' : '-bottom-0.5 -right-0.5 w-3 h-3'}`}></div>
          </div>
          {isOpen && (
            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold text-black truncate">{userName}</p>
              <p className="text-xs text-gray-500 truncate">{userEmail}</p>
              <div className="flex items-center mt-1">
                <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${userRole === 'Admin'
                  ? 'bg-gray-100 text-black'
                  : 'bg-gray-100 text-black'
                  }`}>
                  {userRole}
                </span>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Navigation Menu */}
      <nav className={`flex-1 space-y-2 ${isOpen ? 'p-4' : 'p-3'}`}>
        {menuItems.filter(item => item.show).map((item, index) => {
          const isActive = location.pathname === item.path;
          return (
            <button
              key={index}
              onClick={() => navigate(item.path)}
              className={`w-full flex items-center transition-all duration-200 group rounded-xl ${isOpen ? 'space-x-4 p-4' : 'justify-center p-3'
                } ${isActive
                  ? 'bg-gray-100 border border-gray-200'
                  : 'hover:bg-gray-50'
                }`}
            >
              <div className={`flex-shrink-0 rounded-lg flex items-center justify-center transition-all duration-200 ${isOpen ? 'w-8 h-8' : 'w-10 h-10'
                } ${isActive
                  ? 'bg-black text-white'
                  : 'text-gray-600 group-hover:text-black group-hover:bg-gray-100'
                }`}>
                <svg className={`${isOpen ? 'w-5 h-5' : 'w-6 h-6'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  {item.name === 'Dashboard' && (
                    <>
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2-2z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 5a2 2 0 012-2h4a2 2 0 012 2v6H8V5z" />
                    </>
                  )}
                  {item.name === 'Users Management' && (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
                  )}
                  {item.name === 'AI Agents' && (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  )}

                  {item.name === 'Feedbacks' && (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v12a2 2 0 01-2 2h-3l-4 4z" />
                  )}
                  {item.name === 'Profile' && (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  )}
                  {item.name === 'Analytics' && (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                  )}
                </svg>
              </div>
              {isOpen && (
                <div className="flex-1 text-left">
                  <span className={`text-sm font-medium transition-colors duration-200 ${isActive ? 'text-black' : 'text-gray-700 group-hover:text-black'
                    }`}>
                    {item.name}
                  </span>
                </div>
              )}
              {isActive && isOpen && (
                <div className="w-2 h-2 bg-black rounded-full"></div>
              )}
            </button>
          );
        })}
      </nav>

      {/* Logout Button */}
      <div className={`border-t border-gray-200 ${isOpen ? 'p-4' : 'p-3'}`}>
        <button
          onClick={handleLogout}
          className={`w-full flex items-center bg-gray-100 hover:bg-gray-200 transition-all duration-200 group border border-gray-200 rounded-xl ${isOpen ? 'space-x-4 p-4' : 'justify-center p-3'
            }`}
        >
          <div className={`flex-shrink-0 rounded-lg bg-gray-200 group-hover:bg-gray-300 flex items-center justify-center transition-all duration-200 ${isOpen ? 'w-8 h-8' : 'w-10 h-10'
            }`}>
            <svg className={`text-black ${isOpen ? 'w-5 h-5' : 'w-6 h-6'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
          </div>
          {isOpen && (
            <span className="text-sm font-medium text-black group-hover:text-black">
              Logout
            </span>
          )}
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
